/**
 * The three states a protected surface can be in while Clerk resolves the
 * session. Kept as a pure function so the redirect decision is unit-testable and
 * the component (RequireAuth) stays a thin render of the result.
 *
 * - `loading` — Clerk hasn't resolved yet; render a placeholder, never the app
 *   (this is what prevents a flash of protected UI).
 * - `anon`    — resolved + signed out; redirect to sign-in.
 * - `authed`  — resolved + signed in; render the protected children.
 */
export type AuthGate = "loading" | "anon" | "authed";

export interface AuthState {
  /** Clerk has finished loading the session. */
  isLoaded: boolean;
  /** Whether a session exists (`undefined` until loaded). */
  isSignedIn: boolean | undefined;
}

export function resolveAuthGate({ isLoaded, isSignedIn }: AuthState): AuthGate {
  if (!isLoaded) return "loading";
  return isSignedIn ? "authed" : "anon";
}
